import React, { useContext, useEffect, useState } from "react";
import Tabing from "./tabing";
import { Link, useNavigate } from "react-router";
import SettingIcon from "../../../../icons/setting";
import BellIcon from "../../../../icons/bell";
import Grid1Icon from "../../../../icons/grid1";
import { GlobalContext } from "../../../../../context/Context";
import PlusIcon from "../../../../icons/plus";
import EmployeeDirectoryAddUpdate from "../../../../../pages/organization/emplyee-directory/add-update";
import { LogOut } from "lucide-react";
import { CustomDropdown } from "../../../../ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../../ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../ui/dropdown/CustomDropdownMenuList";
import { Alert, Snackbar } from "@mui/material";
import NotificationPanel from "../../../../notification";
import OprationHomePagePopup from "../../../v2/index-v2";
import { useApiCall } from "../../../../custom-hooks/api-call";
import AddDealPackage from "../../../../../pages/dealDemo/add-form";

const TopHeader = ({ topTabs, style, className }) => {
  let { state, dispatch } = useContext(GlobalContext);

  // const [notifications, setNotifications] = useState([
  //   {
  //     id: 1,
  //     user: "Engr Umar Admin",
  //     message: "New chat session created for visitor YLN8eOr",
  //     time: "an hour ago",
  //     isRead: false,
  //   },
  //   {
  //     id: 2,
  //     user: "Engr Umar Admin",
  //     message: "New chat session created for visitor 6nxJkA1",
  //     time: "an hour ago",
  //     isRead: false,
  //   },
  //   {
  //     id: 3,
  //     user: "Engr Umar Admin",
  //     message: "New chat session created for visitor rLPvxOx",
  //     time: "4 hours ago",
  //     isRead: false,
  //   },
  //   {
  //     id: 4,
  //     user: "Engr Umar Admin",
  //     message: "New chat session created for visitor ABC123x",
  //     time: "5 hours ago",
  //     isRead: false,
  //   },
  // ]);

  // const unreadCount = notifications.filter((n) => !n.isRead).length;

  // const markAsRead = (id) => {
  //   setNotifications(
  //     notifications.map((n) => (n.id === id ? { ...n, isRead: true } : n)),
  //   );
  // };

  // const markAllAsRead = () => {
  //   console.log("marksssss all");
  //   // setNotifications(notifications.map(n => ({ ...n, isRead: true })));
  // };

  // NOTIFICATION
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const unreadCount = notifications.length;
  const [refreshLoad, setRefreshLoad] = useState(false);
  const apiCall = useApiCall();

  const markAsRead = async (id) => {
    setIsNotificationOpen(false);
    try {
      const apiData = JSON.stringify({ notification_id: id });
      const resp = await apiCall({
        method: "post",
        url: "read-user-notification",
        data: apiData,
      });
      onSuccess(
        resp?.respMsg ||
        resp?.responseMessage ||
        resp?.message ||
        `Read Notification`,
      );
    } catch (error) {
      onError(
        error?.respMsg ||
        error?.responseMessage ||
        error?.message ||
        `Some Thing Went Wrong`,
      );
    }
  };

  const markAsReadOnly = async (id) => {
    try {
      const apiData = JSON.stringify({ notification_id: id });
      const resp = await apiCall({
        method: "post",
        url: "read-user-notification",
        data: apiData,
      });
      onSuccess(
        resp?.respMsg ||
        resp?.responseMessage ||
        resp?.message ||
        `Read Mark Notification`,
      );
    } catch (error) {
      onError(
        error?.respMsg ||
        error?.responseMessage ||
        error?.message ||
        `Some Thing Went Wrong`,
      );
    }
  };

  const markAllAsRead = async () => {
    setIsNotificationOpen(false);
    try {
      const resp = await apiCall({
        method: "post",
        url: "mark-all-read-notification",
      });
      onSuccess(
        resp?.respMsg ||
        resp?.responseMessage ||
        resp?.message ||
        `Read All Notification`,
      );
    } catch (error) {
      onError(
        error?.respMsg ||
        error?.responseMessage ||
        error?.message ||
        `Some Thing Went Wrong`,
      );
    }
  };

  const getNotification = async () => {
    try {
      const resp = await apiCall({
        method: "get",
        url: "get-user-notification-list",
      });
      setNotifications(resp?.userNotifications);
      setRefreshLoad(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    // getNotification();
  }, []);

  const route = useNavigate();
  const logOut = () => {
    if (sessionStorage.getItem("agent_token")) {
      sessionStorage.removeItem("agent_token");
      sessionStorage.removeItem("agent_user");
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
    route("/login");
    dispatch({ type: "USER_LOGOUT" });
  };
  const [addUser, setAddUser] = useState(false);
  const [showAddDeal, setShowAddDeal] = useState(false);
  const [showAddDealPackage, setShowAddDealPackage] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowAddDeal(false);
    setShowAddDealPackage(false);
    setAddUser(false);
    window.location.reload();
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };
  const [opration, setOpration] = useState(false);

  return (
    <>
      <div className={`${style.headerTop} ${className?.headerTop}`}>
        <Tabing topTabs={topTabs} style={style} className={className} />

        <div
          className={`${style.headerTop_right} ${className?.headerTop_right}`}
        >
          {state?.user?.dashboardRole !== "single" && (
            <>
              <div
                className={`${style.headerTop_addButton} ${className?.headerTop_addButton}`}
                onClick={() => setAddUser(true)}
              >
                <span
                  className={`${style.headerTop_addBtn} ${className?.headerTop_addBtn}`}
                >
                  <PlusIcon />
                </span>
              </div>

              {/* <div className={`${style.headerTop_setting} ${className?.headerTop_setting}`} >
                                <Link
                                    to="/settings/setting"
                                    className={`${style.headerTop_settingBtn} ${className?.headerTop_settingBtn}`}
                                >
                                    <SettingIcon />
                                </Link>
                            </div> */}
              <div
                className={`${style.headerTop_setting} ${className?.headerTop_setting}`}
                onClick={() => {
                  setOpration(true);
                }}
              >
                <span
                  className={`${style.headerTop_settingBtn} ${className?.headerTop_settingBtn}`}
                >
                  <SettingIcon />
                </span>
              </div>

              <div
                className={`${style.headerTop_notification} ${className?.headerTop_notification} !relative`}
              >
                <span
                  onClick={() => setIsNotificationOpen(!isNotificationOpen)}
                  className={`${style.headerTop_notificationBtn} ${className?.headerTop_notificationBtn} cursor-pointer !hover:text-white`}
                >
                  <BellIcon />

                  {unreadCount > 0 && (
                    <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-red-500 rounded-full">
                      {unreadCount}
                    </span>
                  )}
                </span>

                <NotificationPanel
                  isOpen={isNotificationOpen}
                  notifications={notifications}
                  markAsRead={markAsRead}
                  markAllAsRead={markAllAsRead}
                  markAsReadOnly={markAsReadOnly}
                  refreshNotifications={() => {
                    setRefreshLoad(true);
                    getNotification();
                  }}
                  refreshLoad={refreshLoad}
                  onCloase={() => setIsNotificationOpen(!isNotificationOpen)}
                />
              </div>
            </>
          )}

          <CustomDropdown
            className={`${style.headerTop_profile} ${className?.headerTop_profile}`}
            position="bottom-right"
          >
            <CustomDropdownButton
              arrow={false}
              className={`${style.headerTop_profileBtn} ${className?.headerTop_profileBtn} !p-0`}
            >
              {/* <img width={28} height={28} alt='Pic' src={state?.user?.profile_picture} /> */}
              <div className="flex items-center justify-center w-[28px] h-[28px] rounded-full overflow-hidden">
                <p className="capitalize font-semi-bold text-base text-black">
                  {state?.user?.name?.split(" ")?.map((n, i) => n.charAt(0))}
                </p>
              </div>
            </CustomDropdownButton>

            <CustomDropdownMenu>
              <CustomDropdownMenuList onClick={() => logOut()}>
                <div className={"d-flex align-items-center gap-1 !text-sm"}>
                  <LogOut size={"1em"} /> LogOut
                </div>
              </CustomDropdownMenuList>
              <CustomDropdownMenuList>
                <div className={"d-flex align-items-center gap-1 !text-sm"}>
                  <SettingIcon />
                  <Link to="/settings/setting">System Settings</Link>
                </div>
              </CustomDropdownMenuList>
              <CustomDropdownMenuList>
                <div className={"d-flex align-items-center gap-1 !text-sm"}>
                  <PlusIcon />
                  <Link to="/lead-package" target="_blank" rel="noopener noreferrer">Add Lead</Link>
                </div>
              </CustomDropdownMenuList>
              {/* <CustomDropdownMenuList>
                <div
                  className={"d-flex align-items-center gap-1 !text-sm"}
                  onClick={() => {
                    setShowAddDealPackage(true);
                  }}
                >
                  <PlusIcon /> Lead With Package
                </div>
              </CustomDropdownMenuList> */}
            </CustomDropdownMenu>
          </CustomDropdown>

          <div className={`${style.headerTop_nav} ${className?.headerTop_nav}`}>
            <div
              className={`${style.headerTop_navBtn} ${className?.headerTop_navBtn}`}
            >
              <Grid1Icon />
            </div>
          </div>
        </div>
      </div>

      {localStorage.getItem("agent_user") && (
        <span className="bg-orange-100 text-orange-700 text-xs px-2 py-1 rounded-full">
          Agent Mode
        </span>
      )}

      {addUser && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setAddUser(false);
          }}
          onSubmit={onSuccess}
          onError={onError}
        />
      )}
      {opration && (
        <OprationHomePagePopup
          onClosed={() => {
            setTimeout(() => {
              setOpration(false);
            }, 200);
          }}
          onSubmit={onSuccess}
          onError={onError}
        />
      )}

      {showAddDeal && (
        <AddDealPackage
          onClose={() => {
            setTimeout(() => {
              setShowAddDeal(false);
            }, 200);
          }}
          onSubmit={onSuccess}
          onError={onError}
        />
      )}
      {showAddDealPackage && (
        <AddDealPackage
          onClose={() => {
            setTimeout(() => {
              setShowAddDealPackage(false);
            }, 200);
          }}
          fromPackage={true}
          onSubmit={onSuccess}
          onError={onError}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TopHeader;
